/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description react query keys
 */
import _ from 'lodash';
import { QueryClient } from '@tanstack/react-query';

const QUERY_KEYS = {
	assignableRoles: 'query-assignable-roles',
	auditLogs: 'query-audit-logs',
	keycloakUsers: 'query-keycloak-users',
	// accounts
	billingInformation: 'query-billing-information',
	currentUsage: 'query-current-usage',
	addOns: 'query-addon-info',
	addOnStatuses: 'query-addon-statuses',
	activeSubscriptions: 'query-active-subscription',
	invoiceHistory: 'query-invoice-history',
	// eligibility
	eligibilityFormMetadata: 'query-eligibility-form-metadata',
	eligibilityRequests: 'query-eligibility-requests',
	eligibilityPatientID: 'query-eligibility-patient-id',
	selectedPayer: 'query-registered-payers',
	selectedPayersPerNpi: 'query-registered-payers-per-npi',
	payerMaintenance: 'query-payer-maintenance',
	eligibilityCount: 'query-eligibility-count',
	batchEligibilityRequest: 'query-batch-eligibility-request',
	batchRequestById: 'query-batch-request-by-id',
	memberCardById: 'query-member-card-by-id',
	headerMappingSuggestion: 'query-header-mapping-suggestion',
	registeredPayers: 'query-registered-payers',
	serviceTypes: 'query-service-types',
	// claims
	claimStatusRequests: 'query-claim-status-requests',
	claimStatusResponse: 'query-claim-status-response',
	claimWorkLists: 'query-claim-work-lists',
	claimWorkListById: 'query-claim-work-list-by-id',
	claimWorkListEntities: 'query-claim-work-list-entities',
	// admin
	provider: 'query-provider',
	location: 'query-location',
	enrollmentData: 'query-enrollment-data',

	// settings
	generalSettings: 'query-general-settings',
	customOutputFile: 'query-custom-output-file',
	generalSettingsAccessSchema: 'query-general-settings-access-schema',
	// payments
	paymentGateway: 'query-payment-gateway',
	paymentSettings: 'query-payment-settings',
	paymentTemplate: 'query-payment-template',
	searchPatientForPayments: 'query-search-patient-for-payments',
	paymentSubmission: 'query-payment-submission',
	paymentSettingsAccessSchema: 'query-payment-settings-access-schema',

	// workflow
	workflowDetails: 'query-workflow-details',
	organization: 'query-organization',

	// code explorer
	codeSuggestions: 'query-code-suggestions',
	searchCodes: 'query-search-codes',
	codeDetails: 'query-code-details',
	codeHierarchy: 'query-code-hierarchy',
	codeTenantData: 'query-code-tenant-data',
	codeReactions: 'query-code-reactions',
	cptDocument: 'query-cpt-document',
};

const metadataKeys = [
	QUERY_KEYS.eligibilityFormMetadata,
	QUERY_KEYS.selectedPayer,
	QUERY_KEYS.selectedPayersPerNpi,
	QUERY_KEYS.payerMaintenance,
	QUERY_KEYS.registeredPayers,
	QUERY_KEYS.eligibilityRequests,
	QUERY_KEYS.provider,
	QUERY_KEYS.location,
];

const invalidateMetadata = (queryClient: QueryClient): void => {
	_.forEach(metadataKeys, (query) => queryClient.invalidateQueries({ queryKey: [query] }));
};

export { invalidateMetadata };
export default QUERY_KEYS;
